import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import SeatComposition from "../../components/SeatComposition";
import Seat from "../../components/Seat";
import Container from "../../components/Container";
import Image from "../../components/Image";
import Separator from "../../components/Separator";
import { matchSelector } from "../../services/location/reducer";
import "./style.css";

import voteWorthImage from "./assets/graphic1.svg";
import graphic1 from "./assets/opkomst-leeftijd-procent.svg";
import graphic2 from "./assets/opkomst-leeftijd-aantal.svg";
import graphic3 from "./assets/opkomst-blokken.svg";
import graphic4 from "./assets/opkomst-verdeling.svg";

const mapStateToProps = state => ({
  match: matchSelector(state) || {}
});

const round = number => number.toFixed();

class Seats extends Component {
  render() {
    const { match } = this.props;

    const kiesdrempel = round(match.kiesgerechtigden / match.zetels);

    return (
      <Fragment>
        <Container className="seats">
          <p>
            In {match.name} mogen {match.kiesgerechtigden.toLocaleString("nl")}{" "}
            mensen stemmen voor een gemeenteraad van {match.zetels} zetels.
          </p>
          <h3>Gemeenteraad {match.name}</h3>
          <SeatComposition amount={match.zetels} />
          <p className="align align--horizontal">
            <Seat />
            <span>= Een zetel staat voor {kiesdrempel} stemmen.</span>
          </p>
          <p>
            Om te bepalen hoeveel invloed jongeren echt hebben op die zetels,
            moeten we kijken naar drie dingen: het opkomstpercentage, het aantal
            kiesgerechtigde jongeren per gemeente en een combinatie van die
            twee.
          </p>
        </Container>
        <Separator slim />
        <Container>
          <Image slim src={voteWorthImage} />
          <h2>Stap 1: opkomst</h2>
          <p>Laten we eerst even naar het landelijke beeld kijken.</p>
          <p>
            Iedereen ouder dan 18 mag stemmen, maar lang niet iedereen doet dat.
            Bij de vorige gemeenteraadsverkiezingen in 2014 bleven veel jongeren
            thuis.
          </p>
          <p>Per leeftijdscategorie zag de opkomst er toen zo uit:</p>
          <Image src={graphic1} />
          <p>
            Jongeren stemmen dus minder fanatiek dan ouderen, maar er is nog
            iets anders aan de hand.
          </p>
        </Container>
        <Separator />
        <Container>
          <h2>Stap 2: leeftijdsverdeling</h2>
          <p>
            Niet alleen stemmen jongeren minder, ze zijn ook met minder. In 2014
            was een kwart van de volwassenen jonger dan 35 jaar.
          </p>
          <Image src={graphic2} caption="Verdeling leeftijden" />
        </Container>
        <Separator />
        <Container>
          <h2>Stap 3: verdeling stemmen</h2>
          <p>
            Als we nu stap 1 en 2 combineren, weten we de totale invloed van
            jongeren op de gemeenteraadsverkiezingen.
          </p>
          <p>
            Jongeren tot 35 jaar brachten vier jaar geleden 1,5 miljoen stemmen
            uit.
          </p>
          <Image src={graphic3} />
          <p>
            Bovenstaande blokken lijken vrij groot, maar als je ze vergelijkt
            met de stemmen van ouderen vallen ze in het niet.
          </p>
          <Image className="wobble" src={graphic4} />
          <p>
            Slechts 21 procent van de stemmen werd uitgebracht door jongeren.
          </p>
        </Container>
      </Fragment>
    );
  }
}

export default connect(mapStateToProps)(Seats);



// WEBPACK FOOTER //
// ./src/scenes/Seats/index.js